import React, { useEffect, useMemo, useState } from 'react'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import { Modal } from 'react-bootstrap'

const ModalPreviewSptTte = ({ showSptTte, handleCloseViewSptTte, rowData }) => {

    let pbUmkuService = useMemo(() => new PbUmkuService(), [])

    const [dataTte, setDataTte] = useState(null)

    useEffect(() => {
        if (!rowData) return
        const fetchData = async () => {
            try {
                const resTte = await pbUmkuService.viewTte(rowData.idIzin)
                // console.log(resTte.data)
                setDataTte(resTte.data)
            } catch (error) {
                setDataTte(null)
            }
        }
        fetchData()
    }, [pbUmkuService, rowData])

    return (
        <>
            <Modal show={showSptTte} onHide={handleCloseViewSptTte} size='xl'>
                {
                    dataTte &&
                    <iframe
                        src={dataTte.linkTerima}
                        title='Preview PDF'
                        width="100%"
                        height="800px"
                    ></iframe>
                }
            </Modal>
        </>
    )
}

export default ModalPreviewSptTte